import { Divider, Grid } from "@mui/material";
import React from "react";
import { FlexCenter, FlexRowSB } from "../../../constant/CustomeStyle";
import { styled } from "@mui/material/styles";

const boxBorder = "1px solid #A5A5A5";
const CustomeGridLeft = styled(Grid)(({ idx, len }) => ({
  borderTop: boxBorder,
  borderLeft: boxBorder,
  borderBottom: `${idx === len - 1 ? boxBorder : "none"}`,
  fontWeight: `${idx === len - 1 ? "500" : "300"}`,
}));

const CustomeGridRight = styled(Grid)(({ idx, len }) => ({
  borderTop: boxBorder,
  borderLeft: boxBorder,
  borderRight: boxBorder,
  borderBottom: `${idx === len - 1 ? boxBorder : "none"}`,
  fontWeight: `${idx === len - 1 ? "500" : "300"}`,
}));

const salesReport = [
  { A: { A1: "", A2: "" }, B: "Net Total" },
  { A: { A1: "Sales Total", A2: "" }, B: "67454" },
  { A: { A1: "Vat. (7)", A2: "" }, B: "354.55" },
  { A: { A1: "SD (2)", A2: "" }, B: "52.35" },
  { A: { A1: "Grand Total", A2: "" }, B: "7545.00" },
];

const incomeReport = [
  { A: { A1: "Cash", A2: "100%" }, B: "7545.00" },
  { A: { A1: "Total Income", A2: "" }, B: "7545.00" },
];

const generalInfo = [
  { A: { A1: "Extra Items", A2: "" }, B: "-" },
  { A: { A1: "Pre-Tax Service Total", A2: "" }, B: "-" },
];

const orderReport = [
  { A: { A1: "Ticket Count", A2: "" }, B: "Net Total" },
  { A: { A1: "Number of Gusts", A2: "" }, B: "64754" },
  { A: { A1: "Grand/Total Ticket", A2: "" }, B: "354.55" },
  { A: { A1: "Sales Total", A2: "" }, B: "52.55" },
];

const departmentReport = [
  { A: { A1: "Restaurant", A2: "" }, B: "7545.00" },
  { A: { A1: "Total", A2: "" }, B: "7545.00" },
];

// {A: {A1: "", A2: ""}, B: ""},

const WorkPeriodReport = () => {
  return (
    <div>
      <TopTitle />
    </div>
  );
};

const TopTitle = () => (
  <div
    style={{
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    <FlexCenter
      style={{
        width: "100%",
        height: 48,
        background: "#0E5A41",
        color: "#FFF",
      }}
    >
      Work Period Report
    </FlexCenter>

    <FlexCenter style={{ width: "100%" }}>
      <div
        style={{
          marginTop: 10,
          width: 442,
          color: "#333C4B",
          fontSize: 16,
        }}
      >
        Period: 09 January 2022 17:29 - 09 January 2022 20:30 Taj kitchen, Dhaka
        Vat Reg-002545457875, Mushak6.3
      </div>
    </FlexCenter>

    <ReportTable myArray={salesReport} title={"SALES"} />
    <ReportTable myArray={incomeReport} title={"Income"} />
    <ReportTable
      myArray={departmentReport}
      title={"Department Name"}
      title2={"Sales"}
    />
    <ReportTable myArray={generalInfo} title={"General Information"} />
    <ReportTable myArray={orderReport} title={"Order"} />
  </div>
);

const ReportTable = ({ myArray, title, title2 }) => (
  <div
    style={{
      margin: "20px 0",
      fontSize: 12,
      fontWeight: "300",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    {title2 ? (
      <TableHeadTwo title={title} title2={title2} />
    ) : (
      <TableHead title={title} />
    )}
    <Grid container sx={{ background: "#FFf" }}>
      {myArray.map((item, idx) => (
        <>
          <CustomeGridLeft item xs={6} idx={idx} len={myArray.length}>
            <FlexRowSB style={{ margin: "0 10px" }}>
              <div>{item.A.A1}</div>
              <div>{item.A.A2}</div>
            </FlexRowSB>
          </CustomeGridLeft>
          <CustomeGridRight item xs={6} idx={idx} len={myArray.length}>
            <div style={{ marginRight: 10, textAlign: "right" }}>{item.B}</div>
          </CustomeGridRight>
        </>
      ))}
    </Grid>
  </div>
);

const TableHead = ({ title }) => (
  <FlexCenter
    style={{
      border: "1px solid #A5A5A5",
      height: 38,
      color: "#FFF",
      background: "#5D687A",
      fontSize: 16,
      fontWeight: "500",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    {title}
  </FlexCenter>
);

const TableHeadTwo = ({ title, title2 }) => (
  <Grid
    container
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    style={{
      border: "1px solid #A5A5A5",
      height: 38,
      color: "#FFF",
      background: "#5D687A",
      fontSize: 16,
      fontWeight: "500",
      fontFamily: `Poppins, sans-serif`,
      padding: "0 10px",
    }}
  >
    <Grid item xs={6}>
      <div style={{ textAlign: "left", borderRight: boxBorder }}>{title}</div>
    </Grid>
    <Grid item xs={6}>
      <div style={{ textAlign: "right" }}>{title2}</div>
    </Grid>
  </Grid>
);

export default WorkPeriodReport;
